import React, { Component } from 'react'
import Input from './Input'
import { LanguageConsumer } from '../lib/LanguageContext'
import './Autocomplete.css'

class Autocomplete extends Component {

  state = {
    selected: -1,
    filter: '',
    matchingValues: []
  }
  
  componentDidMount() {
      document.addEventListener('mousedown', this.handleClickOutside)
      let filter = this.props.value ? new RegExp("(^|\\s)" + this.props.value, "i") : new RegExp(".*", "i")
      let matchingValues = this.props.list.filter(l => filter.test(l))
      this.setState({filter, matchingValues})

  }

  componentWillUnmount() {
      document.removeEventListener('mousedown', this.handleClickOutside)
  }

  componentDidUpdate(nextProps) {
    if(nextProps.value !== this.props.value) {
      let filter = this.props.value ? new RegExp("(^|\\s)" + this.props.value, "i") : new RegExp(".*", "i")
      let matchingValues = this.props.list.filter(l => filter.test(l))
      this.setState({filter, matchingValues})
    }
  }

  open = () => this.props.open(this.props.name)
  
  close = () => {
    let selected = -1 
    this.setState({selected})
    this.props.close(this.props.name)
  }

  handleClickOutside = (e) => {
      if (this.wrapperRef && !this.wrapperRef.contains(e.target) && this.props.active) {
        this.close()
      }
  }

  setWrapperRef = (node) => {
      this.wrapperRef = node;
  }

  onChange = (name, value, selected) => {
    this.props.onChange(name, value)
    if(selected) {
      this.close()
    }
  }

  handleClick = (e) => {
      e.preventDefault();
      this.open();
  }

  handleKeyDown = (e) => {
    e.stopPropagation()
    if(e.key === 'ArrowDown') {
      this.arrowDown()
    } else if(e.key === 'ArrowUp') {
      this.arrowUp()
    } else if(e.key === 'Enter') {
      this.selectValue()
    }
  }

  arrowUp = () => {
    let matchingLen = this.state.matchingValues.length
    let selected = this.state.selected
    if(selected > 0) {
      selected -= 1
    } else {
      selected = matchingLen - 1
    } 
    this.setState({selected})
  }

  arrowDown = () => {
    let matchingLen = this.state.matchingValues.length
    let selected = this.state.selected
    if(selected !== matchingLen - 1) {
      selected += 1
    } else {
      selected = 0
    }
    this.setState({selected})
  }

  selectValue = () => {
    if(this.props.active) {
      let selected = this.state.selected
      if(selected >= 0) {
        let matching = this.state.matchingValues[selected]
        this.onChange(this.props.name, matching)
      }
      this.close() 
    } else {
      this.open()
    }
  }


 render = () => {

   return (
     <LanguageConsumer>
      {({polyglot}) =>
       (<div className={`Autocomplete ${this.props.active ? 'show' : 'hidden'}`}>
        
         <span className='mobileSelect-background'></span>
         <span ref={this.setWrapperRef} className={`select-group dropdown-group ${this.props.active ? 'show' : 'hidden'}`}>
           <Input type='text' name={this.props.name} label={this.props.label} value={this.props.value} onChange={this.onChange} onFocus={this.open} onKeyDown={this.handleKeyDown} />
           <div className='select-dropdown'>
             <span className='mobile-input'>
                  <Input type='text' name={this.props.name} label={this.props.label} value={this.props.value} onChange={this.onChange} onFocus={this.open} onKeyDown={this.handleKeyDown} />
             </span>
              <div className="closeModal"  onClick={() => this.props.close(this.props.name)}>
                  <div id='x-icon'>
                      <span />
                      <span />
                      <span />
                      <span />
                  </div>
              </div>
              <ul className='Dropdown-list single-select'>
                {this.state.matchingValues.map((l,i) =>
                  <li key={`au_${this.props.name}_${i}`} className={`${this.props.value  === l || this.state.selected === i ? 'active' : ''}`}
                        onClick={() => this.onChange(this.props.name, l, true)}>
                        <span className='selection' >
                            {l}
                        </span>
                      </li>)}
                 {!this.state.matchingValues.length  && (
                   <li className='no-results'>
                     <span>
                       {polyglot.t('noMatchingResults')}
                     </span>
                   </li>
                 )}
              </ul>
          </div>
          </span>
        </div>)}
      </LanguageConsumer>
     )
  }
}

export default Autocomplete



// WEBPACK FOOTER //
// ./src/components/Autocomplete.js